import axios from 'axios';

/*--------------------------------------------------------------
Colours
--------------------------------------------------------------*/
export const getColours = async () => {
    const { data } = await axios.get('/api/colours');
    return data.colours;
};

export const getColoursGM = async () => {
    const { data } = await axios.get('/api/gm/colours');
    return data.colours;
};

export const createColour = async (colour: string) => {
    const { data } = await axios.post('/api/colours', { colour });
    return data;
};

export const deleteColour = async (colourId: number) => {
    await axios.delete(`/api/colours/${colourId}`);
};

export const bulkCreateColours = async file => {
    await axios.post(
        '/api/colours/bulkCreate',
        { file },
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );
};

export const exportColours = async () => {
    const res = await axios.post('/api/colours/export');
    return res.data;
};

/*--------------------------------------------------------------
Colour Palettes
--------------------------------------------------------------*/
export const getColourPalettes = async () => {
    const { data } = await axios.get('/api/colourPalettes');
    return data.colourPalettes;
};

export const getColourPalette = async colourPaletteId => {
    const { data } = await axios.get(`/api/colourPalettes/${colourPaletteId}`);
    return data.colourPalette;
};

export const deleteColourPalette = async colourPaletteId => {
    await axios.delete(`/api/colourPalettes/${colourPaletteId}`);
};

export const createColourPalette = async (inputName: string, colours) => {
    const name = inputName === '' ? 'Default Name' : inputName;
    const { data } = await axios.post('/api/colourPalettes', { name, colours });
    return data;
};

export const editColourPalette = async (inputName: string, colours, colourPaletteId: number) => {
    const name = inputName === '' ? 'Default Name' : inputName;
    const { data } = await axios.put(`/api/colourPalettes/${colourPaletteId}`, { name, colours, colourPaletteId });
    return data;
};

export const exportColourPaletteColours = async (colourPaletteId: number) => {
    const res = await axios.post(`/api/colourPalettes/${colourPaletteId}/export`);
    return res.data;
};

/*--------------------------------------------------------------
Users
--------------------------------------------------------------*/
export const createUser = async (username: string, password: string) => {
    const { data } = await axios.post('/auth/users', { username, password });
    return data;
};

export const logInUser = async (username, password) => {
    const { data } = await axios.post('/auth/users/login', { username, password });
    return data;
};

export const logoutUser = async () => {
    await axios.post('/auth/users/logout');
};
